export {
  ErrorBoundary,
  type ErrorBoundaryProps,
} from './ErrorBoundary';
